import { useSettings } from '@/react/portainer/settings/queries';

export function useEdgeComputeConfigured({
  enabled,
}: { enabled?: boolean } = {}) {
  return useSettings(
    (settings) =>
      !!(
        settings.EnableEdgeComputeFeatures &&
        settings.EdgePortainerUrl &&
        settings.Edge.TunnelServerAddress
      ),
    enabled
  );
}
